<template>
  <div class="version-wrap" v-if="loading">
    <div class="version-wrap-header">
      <div class="version-wrap-header-left">
        <span class="title">版本对比</span>
        <span @click="goBack">
          保存并返回
        </span>
        <div v-if="controlBtn.userButtons">
          <span @click="handleTaskShow(6)" v-if="controlBtn.userButtons.indexOf('提交任务') != -1">提交任务</span>
          <span @click="handleTaskShow(6)" v-if="controlBtn.userButtons.indexOf('提交返修') != -1">提交返修</span>
          <span @click="handleTaskShow(12)" v-if="controlBtn.userButtons.indexOf('取消任务')!= -1">取消任务</span>
          <span @click="handleTaskShow(7)" v-if="controlBtn.userButtons.indexOf('通过') != -1">通过</span>
          <span @click="handleTaskShow(9)" v-if="controlBtn.userButtons.indexOf('返修') != -1">返修</span>
          <span @click="handleTaskShow(8)" v-if="controlBtn.userButtons.indexOf('未通过') != -1">未通过</span>
        </div>
      </div>
      <div>
        <span>
          翻页联动
          <a-checkbox v-model="linkageFlag"/>
        </span>
      </div>
    </div>
    <div  class="version-wrap-content">
      <div class="left" v-if="leftType">
        <Info
          v-if="leftType == 'info'"
          :taskDataInfo="taskDataLeft"/>
        <Menu
          v-if="leftType == 'menu'"
          :taskDataMenu="taskDataLeft.imgList"
          @handlePageSize="handlePageSize"
          type="left"
          :index="leftIndex"
        />
      </div>
      <div class="comparison">
        <Cont
          :taskData="taskDataLeft"
          :index="leftIndex" 
          @handlePage="handlePage"
          type="left"
          @toggleMenu="toggleMenu"
          @handlePageSize="handlePageSize"
          :taskId="taskId"
          @openModal="openModal"
          @refreshTaskData="handleTaskData"
          :checkCurrentMenu="leftType"
          :parentType="type"
        />
        <Cont
          :taskData="taskDataRight"
          :index="rightIndex"
          @handlePage="handlePage"
          type="right"
          @toggleMenu="toggleMenu"
          @handlePageSize="handlePageSize"
          :taskId="taskId"
          @openModal="openModal"
          @refreshTaskData="handleTaskData"
          :checkCurrentMenu="rightType"
          :parentType="type"
        />
      </div>
      <div class="right" v-if="rightType">
        <Info
          v-if="rightType == 'info'"
          :taskDataInfo="taskDataRight"/>
        <Menu
          v-if="rightType == 'menu'"
          :taskDataMenu="taskDataRight.imgList"
          @handlePageSize="handlePageSize"
          type="right"
          :index="rightIndex"
        />
      </div>
    </div>
    <versionModal
      :visible="visible"
      :closeModal="closeModal"
      :data="taskData"
      :type="checkedType"
      @changeVersion="changeVersion"
    />

    <TaskFeedBack
      :feedbackVisible="feedbackVisible"
      :workStatus="workStatus"
      :flowId="flowId"
      @handleClose="handleTaskClose"
      @handleOk="handleTaskOk"
    />
  </div>
</template>

<script>
import TaskFeedBack from '@/components/TaskFeedBack'
import versionModal from '../../components/versionModal.vue'
import { getStudyDrop, addWork, updateFlowDays, versionCheck, versionButtons, getVersionJiaoben } from '@/api/fileContrast'
import Info from './Info.vue'
import Menu from './Menu.vue'
import Cont from './Content.vue'

export default {
  components: {
    versionModal,
    Info,
    Cont,
    Menu,
    TaskFeedBack
  },
  data() {
    return {
      visible: false,
      taskDataLeft: {},
      taskDataRight: {},
      leftIndex: 0,
      rightIndex: 0,
      loading: false,
      leftType: '',
      rightType: '',
      taskId: '',
      checkedType: 'left',
      linkageFlag: false,
      feedbackVisible: false, // 任务意见反馈弹窗
      workStatus: '', // 任务操作状态
      controlBtn: {},
      lastFlowId:'', //外审，流程最新id
      type: 'edit'
    }
  },
  async created() {
    document.title = "在线编辑器版本对比"
    this.loading = false
    this.taskId = this.$route.query.taskId
    this.flowId = this.$route.query.flowId
    this.type = this.$route.query.type || 'edit'

    let res = {}
    if(this.type == 'edit') {
      res = await getStudyDrop({
        taskId: this.taskId
      })
    } else {
      res = await getVersionJiaoben({
        taskId: this.taskId
      })
    }
  
    const { images, lastFlowId } = res.data

    // 获取后台返回的流程id（一个任务能存在多个流程id）
    this.lastFlowId = lastFlowId

    this.taskData = images
    if (!images.length) {
      this.loading = true
      return
    }

    this.taskDataLeft = images[0]
    this.taskDataRight = images[1]
    this.loading = true

    if (this.type == 'edit') {
      this.getButtons()
    }
    
  },
  methods: {
    // 按钮控制
    async getButtons() {
      const ret = await versionButtons({
        taskId: this.taskId
      })
  
      ret.data.userButtons = ret.data.userButtons.split(',')
      this.controlBtn = ret.data
    },
    // 图片翻页
    handlePage(type) {
      if (this.linkageFlag) {
        if (type == 'leftPrev') {
          this.leftIndex = this.leftIndex - 1
          this.rightIndex = this.leftIndex
        } else if (type == 'leftNext') {
          this.leftIndex = this.leftIndex + 1
          this.rightIndex = this.leftIndex
        } else if (type == 'rightPrev') {
          this.rightIndex = this.rightIndex - 1
          this.leftIndex = this.rightIndex
        } else if (type == 'rightNext') {
          this.rightIndex = this.rightIndex + 1
          this.leftIndex = this.rightIndex
        }
      } else {
        if (type == 'leftPrev') {
          this.leftIndex = this.leftIndex - 1
        } else if (type == 'leftNext') {
          this.leftIndex = this.leftIndex + 1
        } else if (type == 'rightPrev') {
          this.rightIndex = this.rightIndex - 1
        } else if (type == 'rightNext') {
          this.rightIndex = this.rightIndex + 1
        }
      }
    },
    // 跳转页码
    handlePageSize({type, size}) {
      this[`${type}Index`] = size

      if (!this.linkageFlag) return
      if (type === 'left') {
        this.rightIndex = size
      } else {
        this.leftIndex = size
      }
    },
    // 头部按钮切换
    toggleMenu({menuType, type}) {
      this[`${type}Type`] = menuType
    },
    /**
     * 打开弹窗
     */
    openModal(type) {
      this.visible = true;
      this.checkedType = type
    },
    /**
     * 关闭弹窗
     */
    closeModal() {
      this.visible = false;
    },
    // 版本调阅
    changeVersion({type, index}) {
      if (type == 'left') {
        this[`taskDataLeft`] = this.taskData[index]
      } else {
        this[`taskDataRight`] = this.taskData[index]
      }
      this.visible = false;
    },
    // 意见反馈弹层显示
    handleTaskShow(status) {
      this.feedbackVisible = true
      this.workStatus = status
    },
    async handleTaskOk(data) {
      // 检测是否设置底本(取消任务不校验)
      if (this.workStatus != 12) {
        await versionCheck({
          taskId: this.taskId
        })
      }
      this.handleSubmitTask(data)
    },
    handleTaskClose() {
      this.feedbackVisible = false
    },
    // 任务相关操作
    async handleSubmitTask({content, grade, reminderDays, completionDays}) {
      this.feedbackVisible = false;
      //外审，提交审核（使用外审的流程id）
      let flowId=this.controlBtn.userButtons.auditProcess=='外审'?this.lastFlowId:this.flowId;
      const res = await addWork({
        workStatus: this.workStatus,
        taskId: this.taskId,
        flowId: flowId,
        grade: grade,
        workRemark: content
      })
      this.$message.success(res.data)
      // 返修功能
      if (this.workStatus == 9) {
        return this.handleUpdateFlowDays(reminderDays, completionDays)
      }
      this.goBack()
    },
    // 返修
    async handleUpdateFlowDays(reminderDays, completionDays) {
      await updateFlowDays({
        flowId: this.flowId,
        reminderDays: reminderDays,
        completionDays: completionDays
      })

      this.goBack()
    },
    // 版本调阅刷新列表
    handleTaskData({metaType, metaId}) {
      this.taskData.map((item) =>{
        if (item.id == metaId) {
          item.metaType = metaType
        }
      })
    },
    // 关闭当前页面并返回
    goBack() {
      var userAgent = navigator.userAgent
      if (userAgent.indexOf('Firefox') !== -1 || userAgent.indexOf('Chrome') !== -1) {
        window.location.replace('about:blank')
      } else {
        window.opener = null
        window.open('', '_self')
      }
      window.close()
      // window.history.back(-1)
    }
  }
};
</script>

<style lang="less">
.version-wrap {
  width: 100%;
  height:100%;

  &-header {
    width: 100%;
    height: 60px;
    background: #947243;
    padding: 0px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #FFFFFF;

    span.title {
      font-size: 24px;
      font-weight: 600;
      color: #FFFFFF;
      cursor: inherit;
    }

    span {
      margin-right: 10px;
    }

    & > div {
      display: flex;
      align-items: center;
    }
    &-left {
      span {
        cursor: pointer;
      }
    }
  }

  &-content {
    width: 100%;
    height: calc(100vh - 60px);
    display: flex;
    background: #EFE8DF;
    justify-content: space-between;

    .left, .right{
      flex: 290px 0 0;
      background-color: #fff;
    }

    .left {
      margin-right: 10px;
    }
    .right {
      margin-left: 10px;
    }

    .comparison {
      flex: 1 0 0;
      width: calc(100% - 600px);
      display: flex;
      height: 100%;
      overflow-y: auto;
      background: #fff;
    }
  }
}
</style>